// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titleR {\n  height: 25px;\n  padding: 16px 20px 8px;\n  color: #191919;\n  line-height: 25px;\n  text-align: right;\n  position: relative;\n}\n.titleR .tt {\n  font-size: 20px;\n  float: left;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
